module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid2_800x702.a0aa5b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid2_800x702.jpg
// module id = QiWw
// module chunks = 0